import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  :host {
    display: contents;
  }

  .login-to-order {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .login-to-order__actions {
    display: flex;
    flex-wrap: wrap;
    gap: ${csSpacing.spacing06};
    margin-top: ${csSpacing.spacing04}
  }
`
